"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApr = void 0;
var launchpadConstants_1 = require("../../launchpadConstants");
/**
 * https://github.com/pancakeswap/pancake-frontend/blob/964a8367c33f7a60ee3815dc783b6c3135d553e6/src/utils/apr.ts
 *
 * Get the APR value in %
 * @param stakingTokenPrice Token price in the same quote currency
 * @param rewardTokenPrice Token price in the same quote currency
 * @param totalStaked Total amount of stakingToken in the pool
 * @param rewardPerBlock
 * @returns Null if the APR is NaN or infinite.
 */
var getApr = function (stakingTokenPrice, rewardTokenPrice, totalStaked, rewardPerBlock) {
    if (!totalStaked ||
        !stakingTokenPrice ||
        !rewardTokenPrice ||
        !rewardPerBlock) {
        return 0;
    }
    try {
        // total reward in any currency, might be BNB, USD = price * tokensPerYear
        var totalRewardPricePerYear = launchpadConstants_1.BLOCKS_PER_YEAR.toNumber() * rewardTokenPrice * rewardPerBlock;
        // total value of staked tokens
        var totalStakedValue = Math.round(stakingTokenPrice * totalStaked);
        var apr = (totalRewardPricePerYear * 100) / totalStakedValue;
        return apr;
    }
    catch (e) {
        console.warn("Failed APR", e);
        return null;
    }
};
exports.getApr = getApr;
